import React from 'react'
import styled from 'styled-components'
import { InsightsSectionProps } from './insights-section.types'

const SectionWrapper = styled.section`
  ${({ theme }) => `
    margin-bottom: ${theme.sizes.l};
  `}
`

const SectionHeader = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${theme.sizes.s};
  `}
`

const Title = styled.h2`
  ${({ theme }) => `
    font-size: ${theme.fontSizes.h3};
    font-weight: ${theme.fontWeights.semiBold};
    color: ${theme.colors.neutral600};
    margin: 0;
  `}
`

const ActionLink = styled.a`
  ${({ theme }) => `
    font-size: ${theme.fontSizes.bodySmall};
    font-weight: ${theme.fontWeights.medium};
    color: ${theme.colors.purple400};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  `}
`

// Card-to-card gap is 16px per Figma (NEX-789). `sizes[4]` is the scale token
// for 1rem.
//
// Default `align-items: stretch` lines up the tops and bottoms of every card
// regardless of which has a taller legend. StatCard's chart slot stays at
// its natural 240px so the extra height ends up as padding below the legend
// rather than stretching the chart away from the header.
const CardGrid = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${theme.sizes[4]};
  `}
`

export const InsightsSection = ({
  title,
  action,
  children,
}: InsightsSectionProps) => (
  <SectionWrapper>
    {(title || action) && (
      <SectionHeader>
        {title && <Title>{title}</Title>}
        {action && <ActionLink href={action.href}>{action.label}</ActionLink>}
      </SectionHeader>
    )}
    <CardGrid>{children}</CardGrid>
  </SectionWrapper>
)
